import React, { useEffect } from "react";
import { connect } from "formik";

function ErrorFocus({ formik }) {
  const { setFieldTouched, errors, isSubmitting } = formik;
  useEffect(() => {
    if (isSubmitting && Object?.keys(errors)?.length > 0) {
      Object?.keys(errors).forEach((key, index) => {
        if (index === 0) {
          let element = document.getElementById(key);
          if (element) {
            element.focus();
          }
        }
        setFieldTouched(key, true);
      });
    }
  }, [isSubmitting]);

  return (
    <>
      <span className="mt-3 error-message">
        {Object?.keys(errors)?.length > 0
          ? errors[Object?.keys(errors)[0]]
          : ""}
      </span>
    </>
  );
}

export default connect(ErrorFocus);
